// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21-2f","label":"styles_label__hxR9b"};